import { reduxForm } from 'redux-form'
import { generateValidation } from 'redux-form-validation'
import { goBack } from 'react-router-redux'
import get from 'lodash/get'

import { updateServicing, fetchServicing } from '../../actions/servicings'
import { getCompletedServices } from '../../selectors/servicings-selector'

import ServicingServicesUpdate from '../../components/servicings/servicing-services-update'

const fields = ['serviceIds']
const validations = {
  serviceIds: {
    minLength: 1
  }
}

function mapStateToProps (state, ownProps) {
  const { workOrderId, servicesServicings = {} } = get(state.servicings, ownProps.servicingId, {})

  const completedServices = getCompletedServices(state, ownProps)

  return {
    initialValues: {
      serviceIds: state.servicings[ownProps.servicingId].services
    },
    workOrderId,
    completedServices,
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      return dispatch(fetchServicing(ownProps.servicingId)).then((fetchAction) => {
        if (fetchAction.error) {
          return new Promise(resolve => resolve(fetchAction.payload.errors))
        } else {
          let servicing = fetchAction.payload.entities.servicings[fetchAction.payload.result]
          if (servicing.status === 'completed') {
            return new Promise(resolve => resolve([{detail: `Area has been completed. Please check the In Progress section to add new Services to this area.`, link: `/in-progress`, linkDescription: 'Go to In Progress.'}]))
          } else if (servicing.status === 'unable') {
            return new Promise(resolve => resolve([{detail: `Area has been marked as unable to complete. Please check the In Progress section to add new Services to this area.`, link: `/in-progress`, linkDescription: 'Go to In Progress.'}]))
          } else {
            return dispatch(updateServicing(ownProps.servicingId, data))
              .then((action) => {
                if (action.error) {
                  return new Promise(resolve => resolve(action.payload.errors))
                } else {
                  return new Promise(resolve => resolve([]))
                }
              })
          }
        }
      })
    },

    onSuccessFeedbackComplete () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    form: 'servicingServicesUpdate',
    fields,
    ...generateValidation(validations)
  },
  mapStateToProps,
  mapDispatchToProps
)(ServicingServicesUpdate)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-services-update-container.js